var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineaCurvaMobilePoliticaPrivacidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 499,
    height: 37,
    viewBox: "0 0 499 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.8486C1 19.8486 128.533 28.345 235 6.16437C333.527 -14.362 498.422 35.5855 498.422 35.5855",
    stroke: "url(#paint0_linear_1767_262)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1767_262",
    x1: -224.184,
    y1: 446.725,
    x2: 525.716,
    y2: 8.56694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#58C787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D5234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineaCurvaMobilePoliticaPrivacidad);
export default __webpack_public_path__ + "static/media/LineaCurvaMobilePoliticaPrivacidad.34c93c1c766ddacfc94cabb4decabd99.svg";
export { ForwardRef as ReactComponent };